import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MenuItem } from 'primeng/primeng';

@Component({
    selector: 'base-crud-navigation-profissional',
    template: `
    <div class="ui-g ui-md ui-lg">
        <div class="ui-g-5 ui-md-2 ui-lg-2">
            <button pButton type="button" label="Voltar" (click)="paginacao($event,false)" class="ui-button-white"></button>
        </div>
        <div class="ui-g-2 ui-md-8 ui-lg-8"></div>
        <div class="ui-g-5 ui-md-2 ui-lg-2" *ngIf="acao != 'visualizar'">
            <button pButton type="button" label="Avançar" *ngIf="(etapa + 1) < etapas.length" (click)="paginacao($event,true)"></button>
            <button pButton type="button" label="Salvar" *ngIf="(etapa + 1) == etapas.length" (click)="paginacao($event)"></button>
        </div>
    </div>`})
export class BaseCrudNavigationProfissionalComponent {
    @Input() acao: String;

    @Input() etapa: number;
    @Output() etapaChange = new EventEmitter<number>();

    @Input() etapas: MenuItem[];
    @Input("form") cadastro: FormGroup;
    @Output() finalizar: EventEmitter<any> = new EventEmitter();

    @Input() useCustomValidation: boolean = false;
    @Input() isValid: boolean = false;

    constructor(public router: Router,
        public activatedRoute: ActivatedRoute) { };

    paginacao(event: any, acao: boolean = true) {
        const controlName = Object.keys(this.cadastro.controls)[this.etapa];
        const etapaReal = this.etapa + 1;
        if (acao && etapaReal === this.etapas.length) {
            this.finalizar.emit(event);
        } else if (acao && etapaReal < this.etapas.length) {
            if (this.useCustomValidation) {
                if (this.isValid) {
                    this.etapa++;
                }else{
                this.touchAll(this.cadastro);
                }
            } else {
                if (this.cadastro.controls[controlName].valid) {
                    this.etapa++;
                } else {
                    this.touchAll(this.cadastro);
                }
            }
        } else if (!acao && etapaReal > 1) {
            if (this.acao !== 'visualizar') {
                this.etapa--;
                this.touchAll(this.cadastro, 'markAsPristine');
            } else {
                this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
            }
        } else if (!acao && etapaReal === 1) {
            this.router.navigate([this.acao === "cadastrar" || this.acao == "cadastro" ? '../' : '../../'],
                { relativeTo: this.activatedRoute });
        }
        this.etapaChange.emit(this.etapa);
    }

    public touchAll(formGroup: FormGroup | FormArray, func = 'markAsDirty', opts = { onlySelf: false }): void {
        Object.keys(formGroup.controls).map((key, index) => {
            let obj = formGroup.controls[key];
            if (obj instanceof FormGroup || obj instanceof FormArray)
                this.touchAll(obj, func, opts);
            else
                obj[func](opts);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/base/base-crud-navigation-profissional.component.ts